/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'send-email': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(7 11)" _stroke="#000"><path pid="0" d="M16.942 9.333a.803.803 0 01-.775.667H4.718a.777.777 0 01-.612-.307A.866.866 0 013.943 9L5.593.667A.803.803 0 016.366 0h11.446c.237 0 .462.113.612.307.15.193.21.448.163.693l-1.646 8.333z"/><path pid="1" d="M5.88.177l4.05 4.592c.539.61 1.422.709 2.07.231L18.407.278"/><path pid="2" d="M.396.833h3.167"/><path pid="3" d="M.396 3.333H2.77"/><path pid="4" d="M.396 5.833h1.583"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/send-email.js